import { render, staticRenderFns } from "./CommittedIndex.vue?vue&type=template&id=5f710aa8&"
import script from "./CommittedIndex.vue?vue&type=script&lang=js&"
export * from "./CommittedIndex.vue?vue&type=script&lang=js&"
import style0 from "./CommittedIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports